/**
 * # Jquery Helper
 * Per la gestione dei contenuti di fallco
 */

if (typeof jQuery === 'undefined') {
  throw new Error('Helper Javascript necessita di jQuery');
}

/**
 * Verifica preliminare requisiti
 * La libreria richiede: jQuery >= 1.9.1
 */
!function ($) {
  'use strict';
  var version = $.fn.jquery.split(' ')[0].split('.');
  if (version[0] < 1 || (version[0] == 1 && version[1] < 7) || (version[0] == 1 && version[1] == 7 && version[2] < 1)) {
    throw new Error('jQuery Helper necessita di jQuery >= 1.7.1');
  }
  //Nel caso la libreria sia inclusa due volte viene lanciato un warning
  if ($.helper !== undefined) {
    console && console.warn('Helper Javascript e\' gia\' in funzione');
  }
  $.helper = {};
}(jQuery);

/**
 * ## helper_url
 * Helper per la gestione degli URL
 */
!function ($, string, w) {

  'use strict';

  if (w.helper_url_disabled === true) return;

  function helper_url(init_with_url) {
    this.location_obj = null;
    this.listeners    = [];

    var url = init_with_url ? init_with_url : w.location.href;

    this.set_url(url);
  }

  helper_url.prototype = {

    addEventListener     : function (event, listener) {
      this.listeners.push({
        name    : event,
        listener: listener
      })
    },
    dispatchEvent        : function (event_name, params) {
      var el = this.location_obj;

      this.listeners.map(function (event) {
        if (event.name === event_name) {
          event.listener($.extend({
              target: el,
              href  : el.href,
              hash  : el.hash,
            }, params || {})
          );
        }
      })
    },
    /**
     * #### set_url
     * Setta l'url base dell'oggetto
     * @param {String}
     */
    set_url: function (href) {
      if (typeof href !== 'string') {
        return href;
      }
      var el            = document.createElement('a');
      el.href           = href || "";
      this.location_obj = el;

      this.listeners.map(function (event) {
        if (event.name === "change") {
          event.listener({
            target: el,
            href: el.href,
            hash: el.hash
          })
        }
      });

      return this;
    },
    /**
     * #### toString
     * Ritorna in formato stringa l'url aggiornato
     * @return {String}
     */
    toString             : function () {
      return this.location_obj.href;
    },
    /**
     * #### get_hostname
     * Ritorna la parte di url relativa al dominio
     * Es: www.fallco.it
     * @return {String}
     */
    get_hostname         : function () {
      if (!this.location_obj) {
        return null;
      }
      return this.location_obj.hostname;
    },
    /**
     * #### get_parameter_by_name
     * Dato il nome di un parametro ne ritorna il valore nella query string
     * @param {String} name
     * @param {boolean?} inHash - Default FALSE - Indica se cercare il parametro nel hash o nella query dell'url.
     * @return {String} il valore o *undefined* se non esiste
     */
    get_parameter_by_name: function (name, inHash) {
      if (!this.location_obj) {
        return null;
      }
      name        = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var regex   = new RegExp("[\\?&#]" + name + "=([^&#]*)"),
          results = regex.exec(inHash ? this.location_obj.hash : this.location_obj.search);
      return results === null ? undefined : decodeURIComponent(results[1].replace(/\+/g, " "));
    },
    /**
     * #### get_url_params
     * Ritorna un *Object* contenente la lista di tutti i parametri presenti nell'url
     * @return {Object}
     */
    get_url_params: function (string) {
      if (!this.location_obj) {
        return {};
      }
      var match,
          search    = /([^&=]+)=?([^&#]*)/g,
          query     = typeof string !== "undefined" ? string : this.location_obj.search.substring(1),
          urlParams = {};
      while (match = search.exec(query)) {
        var key   = this.decode(match[1]);
        var value = this.decode(match[2]);

        if (urlParams[key] !== undefined) {
          if (urlParams[key] instanceof Array) {
            urlParams[key].push(value);
          } else {
            urlParams[key] = [urlParams[key]];
            urlParams[key].push(value);
          }
        } else {
          urlParams[key] = value;
        }
      }
      return urlParams;
    },
    get_hash: function () {
      if (!this.location_obj) {
        return '';
      }

      return this.location_obj.hash;
    },
    get_hash_params: function () {
      return this.get_url_params(this.get_hash().replace("#", ""));
    },
    get_request_file_name: function () {
      if (!this.location_obj) {
        return '';
      }
      return this.toString().split('#')[0].split('?')[0];
    },
    /**
     *
     * @param urlParams
     * @param {boolean?} inHash - Default FALSE - Indica se cercare i parametri nel hash o nella query dell'url.
     * @returns {string}
     */
    get_redirect: function (urlParams, inHash) {
      var p = $.map(urlParams, function (val, name) {
        if (val instanceof Array) {
          var url_array    = [];
          var encoded_name = encodeURIComponent(name);

          val.map(function (entry) {
            url_array.push(encoded_name + '=' + (/%[0-9A-z]{2}/.test(entry) ? val : encodeURIComponent(entry)));
          });

          return url_array.join("&");
        } else {
          return encodeURIComponent(name) + '=' + (/%[0-9A-z]{2}/.test(val) ? val : encodeURIComponent(val))
        }
      }).join('&');

      if (inHash) {
        return this.get_request_file_name() + this.location_obj.search + "#" + p.trim();
      }

      return this.get_request_file_name() + (p.length > 0 ? '?' : '') + p + this.get_hash();
    },
    /**
     * #### change_parameter_by_name
     * Aggiunge o modifica il valore di uno o pi&ugrave parametri nella query string
     * @param {Object} params_obj La lista dei parametri da aggiornare, es: `{nome : valore, nome1 : valore1, nome2 : valore2}`
     * @param {boolean?} inHash - Default FALSE - Indica se cercare i parametri nel hash o nella query dell'url.
     */
    change_parameter_by_name: function (params_obj, inHash) {
      var urlParams = inHash ? this.get_hash_params() : this.get_url_params();

      $.each(params_obj, function (i, v) {
        urlParams[i] = v;
      });

      this.set_url(this.get_redirect(urlParams, inHash));

      if (inHash){
        var el = this.location_obj;

        this.listeners.map(function (event) {
          if (event.name === "hashchange") {
            event.listener({
              target: el,
              href  : el.href,
              hash  : el.hash,
              newURL: el.toString()
            })
          }
        })
      }

      return this;
    },
    /* params string or array */
    /**
     * #### remove_parameter_by_name
     * Dato il nome di uno o pi&ugrave parametri li rimuove se presenti nella query string
     * @param {String|Array} params Se passata una stringa viene cercata e rimossa la singola chiave, altrimenti se passato un array vengono rimosse le corrispondenti chiavi
     * @param {boolean?} inHash - Default FALSE - Indica se cercare il parametro nel hash o nella query dell'url.
     */
    remove_parameter_by_name: function (params, inHash) {
      var urlParams = inHash ? this.get_hash_params() : this.get_url_params();

      if (typeof params === 'string') {
        urlParams[params] !== undefined && delete urlParams[params];
      } else if (typeof params === 'object') {
        $.each(params, function (i, v) {
          urlParams[v] !== undefined && delete urlParams[v];
        });
      }
      this.set_url(this.get_redirect(urlParams, inHash));
      return this;
    },
    decode                  : function (s) {
      var decoded = s.replace(/\+/g, " ");
      try {
        decoded = decodeURIComponent(decoded);
      } catch (e) {}
      return decoded;
    }
  };

  /**
   * ### Expose and Create
   * #### $.helper.url
   * Di default per ogni pagina viene inizializzato un oggetto url e reso disponibile globalmente sulla variabile **$.helper.url**
   */
  $.helper.url = new helper_url();
  /**
   * #### $.helper.url.create
   * All'occorrenza e' possibile creare un nuovo oggetto url invocando questa funzione
   * @param {String} init_with_url Url di inizializzazione
   * @return {Object} Oggetto helper_url
   */
  $.helper.url.create = function (init_with_url) {
    return new helper_url(init_with_url);
  };

  /**
   *  ### Estensione oggetto String
   *  Sono aggiunti al prototipo di *String* con metodi utili.
   *  Es: `var a = './index.php';`
   *  `window.location = `
   *  `a.url_change_parameter_by_name({ 'action': 'go' });`
   */
  if (string) {

    /**
     * #### url_change_parameter_by_name
     * Dato un url valido ne ritorna il corrispondente con il parametro modificato
     * @param {Object} params_obj
     * @return {String} Url modificato
     */
    string.prototype.url_change_parameter_by_name = function (params_obj) {
      var u = $.helper.url.create();
      u.set_url(this.toString());
      return u.change_parameter_by_name(params_obj).toString();
    };

    /**
     * #### url_remove_parameter_by_name
     * Dato un url valido ne ritorna il corrispondente con il/i parametro/i rimosso/i
     * @param {Object} params_obj
     * @return {String} Url modificato
     */
    string.prototype.url_remove_parameter_by_name = function (params_obj) {
      var u = $.helper.url.create();
      u.set_url(this.toString());
      return u.remove_parameter_by_name(params_obj).toString();
    };

    /**
     * #### url_get_parameter_by_name
     * Dato un url valido ritorna il valore per la chiave richiesta
     * @param {String} param
     * @return {String} Url modificato
     */
    string.prototype.url_get_parameter_by_name = function (param) {
      var u = $.helper.url.create();
      u.set_url(this.toString());
      return u.get_parameter_by_name(param);
    };

    /**
     * #### url_get_hostname
     * Dato un url valido ritorna il valore relativo alla proprieta hostname
     * Es: www.fallco.it
     * @return {String}
     */
    string.prototype.url_get_hostname = function () {
      var u = $.helper.url.create();
      u.set_url(this.toString());
      return u.get_hostname();
    };
  }

}(jQuery, String, window);

/**
 * ## helper_order
 * Classe jquery di aiuto per la gestione degli ordinamenti delle tabelle in javascript
 */
!function ($, d, w) {

  'use strict';

  // Classi di dafault utilizzate per gestire gli header
  var default_config = {
    class_orderable: 'orderable',
    class_selected : 'selected'
  };

  function helper_order(current_url_obj, config, target) {
    this.orders  = {};
    this.config  = $.extend({}, default_config, config || {});
    this.url_obj = current_url_obj || $.helper.url;

    if (w.helper_order_disabled === true && !target)
      return;

    this.initialize(this.url_obj.get_parameter_by_name('order') || '',
      this.url_obj.get_parameter_by_name('verso') || '',
      null,
      target);
  }

  helper_order.prototype = {
    /**
     * #### initialize
     * Funzione di inizializzazione
     * E' possibile utilizzare questo metodo per impostare l'ordinamento di default quando nell'url non sono presenti i parametri *order* e *verso*
     * @param {String} order
     * @param {String} verso
     */
    initialize: function (order, verso, isolation, target) {

      order = order.toString();
      verso = verso.toString().toLowerCase();

      var self = this;

      var $order_els = $('.' + this.config.class_orderable, (target ? target : document));

      if (isolation) {
        $order_els = $order_els.filter('[order_isolation="' + isolation + '"]');
      } else {
        $order_els = $order_els.not('[order_isolation]');
      }

      if (this.orders[isolation || ''] && this.orders[isolation || ''].order !== '') {
        return;
      }

      this.orders[isolation || ''] = {order: order, verso: verso};

      $order_els.each(function () {
        var $el = $(this);
        if ($el.data('helper_order_obj')) {
          return;
        }
        $el
          .data('helper_order_obj', self)
          .on('click', function (e) {
            e.preventDefault && e.preventDefault();
            e.stopImmediatePropagation && e.stopImmediatePropagation();
            self.set_new_order($(this)).fire();
            return false;
          });
      });

      if (order.length > 0) {
        $order_els
          .removeClass(default_config.class_selected)
          .filter('[order="' + order + '"]').addClass(verso || 'asc').addClass(default_config.class_selected);
      }

      return this;
    },

    // Imposta il nuovo ordine provveniente da un click
    set_new_order: function ($handler) {
      if (!$handler || $handler.length <= 0) {
        return this;
      }
      var isolation = $handler.attr('order_isolation') || '';
      var new_order = $handler.attr('order');
      if (!new_order) {
        return false;
      }
      if (new_order === this.orders[isolation].order) {
        this.orders[isolation].verso = this.orders[isolation].verso === 'asc' ? 'desc' : 'asc';
      } else {
        this.orders[isolation] = {order: new_order, verso: 'asc'};
      }
      return this;
    },

    // Effettua il redirect verso il nuovo ordinamento
    fire: function () {
      var url_params = {};
      $.each(this.orders, function (isolation, values) {
        if (values.order.length <= 0) {
          return;
        }
        var isolation_str = (isolation.length > 0 ? ('_' + isolation) : '');
        url_params['order' + isolation_str] = values.order;
        url_params['verso' + isolation_str] = values.verso;
      });

      var n_url = this.url_obj.change_parameter_by_name(url_params).toString();
      var event = $.Event("before_change_order.order.helper");
      $(d).trigger(event, n_url);
      if (event.isDefaultPrevented()) {
        return;
      }

      $.helper.loading_frame.show();

      if (this.config.modal) {
        this.config.modal.load_content_from_url(n_url);
      } else {
        w.location = n_url;
      }
    }
  };

  /**
   * ### onReady
   */
  $(function () {
    /**
     * ### Expose and Create
     * #### $.helper.order
     * Al ready viene inizializzato l'ordinamento nella pagina
     * L'oggetto helper order viene esposto globalmente sulla variabile *$.helper.order*
     * Quindi, per impostare l'ordinamento di default della pagina utilizzare quando l'url non espone i parametri di ordinamento utilizzare:
     * `$.helper.order.initialize( chiave_ordine, verso )`
     */
    $.helper.order = new helper_order();
    /**
     * #### $.helper.order.create
     * All'occorrenza e' possibile creare un nuovo oggetto order invocando questa funzione
     * @param {Object} current_url_obj Oggetto helper_url per l'inizializzazione dell'ordinamento
     * @return {Object} Oggetto helper_order
     */
    $.helper.order.create = function (current_url_obj, config, target) {
      return new helper_order(current_url_obj, config, target);
    };
  });

}(jQuery, document, window);

/**
 * ## filter_form
 * Classe jquery di aiuto per la gestione delle form filtro
 */
!function ($, d, w) {

  'use strict';

  if (w.filter_form_disabled === true) return;

  function filter_form() {
  }

  filter_form.prototype = {
    /**
     * #### encode_filter_str
     * Dato un oggetto jQuery di input genera la stringa standard
     * chiave1|valore1^chiave2|valore2^chiave3|valore3
     * Es: `encode_filter_str( $('form').find(':input') )`
     * @param {Object} $input
     * @return {String}
     */
    encode_filter_str: function ($input) {
      var f = '';
      $.each($input.serializeArray(), function (i, v) {
        if (v.name.length <= 0 || v.value.length <= 0) {
          return;
        }
        if (f.length > 0) {
          f += '^';
        }
        f += v.name + '|' + v.value;
      });
      return f;
    }
  };

  /**
   * ### Expose
   * Di default per ogni pagina viene inizializzato un oggetto filter_form e reso disponibile globalmente sulla variabile **$.helper.filter_form**
   */
  $.helper.filter_form = new filter_form();

  // Prototipo per la gestione della form
  function form($form, fillWithUrlData) {
    if ($form === undefined || $form.length <= 0) {
      return;
    }
    this.$form                = $form;
    this.$working_space       = null;
    this.$show_search_buttons = null;
    this.destination_url      = null;
    this.u_obj                = null;
    this.fillWithUrlData      = typeof fillWithUrlData !== 'undefined' ? fillWithUrlData : true;
    // *Array* contenente le chiavi che verranno rimosse dalla query string ogni volta che si eseguo l'operazione di filtro
    this.remove_params        = ['page'];
    this.init();
  }

  form.prototype = {
    init                  : function () {
      var modal = $.helper.modal_popups ? this.$form.get_closest_modal_popup_obj() : undefined;
      this.$working_space  = modal !== undefined ? modal.$modal : $('body').children().not('.modal, .modal-backdrop');
      this.u_obj           = modal !== undefined ? modal.url : $.helper.url;
      this.destination_url = this.$form.data('destination-url');
      this.bind_search().bind_clear().bind_show_hide();

      if (this.fillWithUrlData) {
        this.inizialize_form_filter();
      }
    },
    bind_search           : function () {
      var self = this;
      this.$form.on('submit', function (e) {
        e.preventDefault();
        self.run_search();
        return false;
      });
      return this;
    },
    run_search            : function () {
      var n_url = this.get_filter_url().url_remove_parameter_by_name(this.remove_params);
      var event = $.Event("before_filter");
      $(d).trigger(event, n_url);
      if (event.isDefaultPrevented()) {
        return;
      }
      $.helper.loading_frame.show();
      w.location = n_url;
    },
    get_filter_str        : function () {
      var ff = new filter_form();
      return ff.encode_filter_str(this.$form);
    },
    get_filter_url        : function (f) {
      var f = this.get_filter_str();
      if (this.destination_url !== undefined) {
        if ($.type(this.destination_url) !== 'string' || this.destination_url.length <= 0) {
          return false;
        }
        return f.length > 0 ?
          this.destination_url.url_change_parameter_by_name({'filter': f}) :
          this.destination_url.url_remove_parameter_by_name('filter');
      } else {
        return f.length > 0 ?
          this.u_obj.change_parameter_by_name({'filter': f}).toString() :
          this.u_obj.remove_parameter_by_name('filter').toString();
      }
    },
    bind_clear            : function () {
      var self = this;
      this.$form.find('[name="svuota"], .svuota').filter(':button').on('click', function (e) {
        self.$form.find(':input').not(':button,:submit').val('');
        self.run_search();
      });
      return this;
    },
    bind_show_hide        : function () {
      var self = this;
      this.$show_search_buttons = self.$working_space.find('.show_search:button');
      if (this.$show_search_buttons.length > 1) {
        var i = self.$form.closest('.search_container').index(self.$working_space.find('.search_container'));
        this.$show_search_buttons = this.$show_search_buttons.eq(i);
      }
      this.$show_search_buttons.on('click', function () {
        var $container  = self.$form.closest('.search_container');
        var is_on       = $container.hasClass('on');
        var hasCollapse = $container.hasClass('collapse') || $container.hasClass('collapsing');
        var btn = $(this);

        if (hasCollapse) {
          if (!is_on) {
            $container.addClass('on');

            if (this.localName.toLowerCase() === 'input') {
              btn.val((is_on ? 'Mostra' : 'Nascondi') + ' filtri');
            }else{
              btn.html(btn.html().replace('Mostra', 'Nascondi'))
            }
          }

          $container.collapse(is_on ? 'hide' : 'show')
            .one('hidden.bs.collapse', function() {
              $container.removeClass('on');

              if (this.localName.toLowerCase() === 'input') {
                btn.val((is_on ? 'Nascondi' : 'Mostra') + ' filtri');
              }else{
                btn.html(btn.html().replace('Nascondi', 'Mostra'))
              }
            });

        } else {
          $container[is_on ? 'removeClass' : 'addClass']('on');
          btn.val((is_on ? 'Mostra' : 'Nascondi') + ' filtri');
        }

      });
      return this;
    },
    inizialize_form_filter: function () {
      var self = this,
          parameters_attr = self.u_obj.get_parameter_by_name('filter') || '';
      if (parameters_attr.length <= 0) {
        return;
      }
      var parameters = parameters_attr.split('^');
      $.each(parameters, function (i, coppia) {
        var f = coppia.split('|');
        var $input = self.$working_space.find(':input[name="' + f[0] + '"]');
        if ($input.is(':checkbox,:radio')) {
          $input.filter('[value="' + f[1] + '"]').prop('checked', true);
        } else {
          $input.val(f[1]);
        }

        // Se l'elemento viene gestito dalla libreria chosen, triggera l'update.
        if($input.data("chosen")) {
          $input.trigger("chosen:updated");
        }
      });
      self.$show_search_buttons.eq(0).trigger('click');
    }
  };

  /**
   * #### $.fn.helper_filter_form()
   * Sulla proprieta' $.fn e' resa disponibile questa funzione per attivare manualmente su di una o piu' form la gestione dei filtri
   * Es: `$('form').helper_filter_form()`
   */
  $.fn.helper_filter_form = function (fillWithUrlData) {
    $.each(this, function () {
      var $this = $(this);
      if ($this.data('helper_filter_form') !== undefined) {
        return;
      }
      var ff = new form($this, fillWithUrlData);
      $this.data('helper_filter_form', ff);
    });
    return this;
  };

  /**
   * ### onReady
   * Al ready si attiva in automatico le form esistenti aventi classe *search*
   * Viene inoltre attivato un controllo in ascolto per eventuali popup modali contenenti form filtro al loro interno, anche in questo caso vengono cercate form con classe *search*
   * */
  $(function () {
    $('form.search').helper_filter_form();
    $(d).on('shown.modal.helper loaded.modal.helper', function (e, modal_obj) {
      modal_obj.$modal.find('form.search').helper_filter_form();
    });
  });

}(jQuery, document, window);

/**e
 * ## modal_popups
 * Classe jquery di aiuto per la gestione dei popup modali in javascript
 * **Attenzione necessita di bootstrap**
 */
!function ($, d, w) {

  'use strict';

  if (w.helper_modal_popups_disabled === true) return;

  //Creazione e implementazione del prototipo per la configurazione del singolo popup modale
  function modal_popup(titolo, width, opt) {
    this.$modal       = [];
    this.url          = undefined;
    this.order        = undefined;
    this.url_params   = { 'modal_window': 'true' };
    this.form_changed = false;
    this.position     = {
      x: 0,
      y: 0
    };
    /**
     * @type {ModalOptions.options}
     */
    this.options = {};
    this.initialParms = {};
    this.initialize(titolo, width, opt);
  }

  modal_popup.prototype = {
    initialize    : function (titolo, width, opt) {
      var modal_size = width;

      this.initialParms = {
        titolo: titolo,
        width: width,
        options: opt
      }

      $.extend(this.options, opt);
      /**
       * Quando si carica il contenuto del modale in un iframe,
       * se la pagina interna usa header_with_bootstrap, questo non caricherà alcun file in quanto il
       * parametro modal_window è settato di default a true.
       *
       * Se lo si setta a false, questo problema non sussiste più.
       *
       * @example
       * $.helper.modal_popups.popup('titolo', 'dimensione', 'url_pagina', true, { iframe: true, url_params: { modal_window: false }})
       */
      if (opt.url_params) {
        $.extend(this.url_params, opt.url_params);
      }

      var iframeHeight = opt.iframe_height || '120px';

      if (typeof width === "number" || Number(width) > -1) {
        // caso in cui il parametro "width" sia un Numero
        width += "px";
        modal_size = undefined;

      } else if (width.toString().search(/(px)|(%)/) > -1) {
        // caso in cui il parametro "width" sia una stringa con "px" o "%"
        modal_size = undefined;

      } else if (width.toString().search(/(px)|(%)/) === -1) {
        // caso in cui il parametro "width" sia una classe
        modal_size = "modal-" + width;
        width      = undefined;
      }

      //controlliamo la versione di Bootstrap caricata e modifichiamo gli attributi per il close button
      var close_attr = {'type': 'button', 'class': 'close btn-close close-in-title', 'data-dismiss' : 'modal', 'aria-label' : 'Chiudi'};
      if($.fn.tooltip.Constructor.VERSION.startsWith("5")){
        // l'attributo data-dismiss è stato aggiornato a data-bs-dismiss,
        // link alla documentazione: https://getbootstrap.com/docs/5.0/migration/#javascript
        close_attr = {'type': 'button', 'class': 'close btn-close close-in-title', 'data-bs-dismiss' : 'modal', 'aria-label' : 'Chiudi'};
      }

      titolo = titolo || '';

      if ($('#modal_popup_matrice').length) {
        this.$modal = $('#modal_popup_matrice').clone().find('.modal-title').text(titolo);
      } else {
        var mp      = $('.modal_popup');
        this.$modal = $('<div></div>')
          .attr({'class': 'modal fade modal_popup', 'tabindex': '-1', 'role': 'dialog', 'aria-labelledby': 'mph_' + mp.length})
          .append(
            $('<div></div>')
              .attr({'class': 'modal-dialog' + (modal_size ? " " + modal_size : ""), 'role': 'document', 'style': '' + (width ? ('width:' + width + ';') : '') + 'margin-top:' + ((mp.length + 1) * 40) + 'px;'})
              .append(
                $('<div></div>')
                  .attr({'class': 'modal-content'})
                  .append(
                    $('<div></div>')
                      .attr({'class': 'modal-header' + (opt.draggable ? ' draggable' : '')})
                      .append(
                        $('<h5></h5>')
                          .attr({'id': 'mph_' + mp.length, 'class': 'modal-title'})
                          .html(titolo),
                        $('<button></button>')
                          .attr(close_attr)
                          .html('<span aria-hidden="true">&times;</span>')
                      ),
                    $('<div></div>')
                      .attr({'class': 'modal-body'})
                      .append(
                        (opt.iframe) ? $("<iframe style='width: 100%; min-height:" + iframeHeight + "' frameborder=\"0\" scrolling=\"no\"/>") : null
                      )
                  )
              )
          );
        this.show_loading();
      }
      this.$modal.data('modal_popup_obj', this);
      return this;
    },
    trigger_event : function (event_name) {
      var event = $.Event(event_name + ".modal.helper");
      $(d).trigger(event, this);
    },
    set_content   : function (content) {
      var self = this;

      // Caso in cui il contenuto deve essere caricato in un iframe
      if (this.options.iframe){
        var iframe = this.$modal.find('.modal-body iframe');
        iframe.css({
          border: 0
        });

        iframe.on("load", function (e) {
          self.set_title();

          var iframeWindow = this.contentWindow;

          self.$modal.find('.modal-body iframe').css({
            background: "transparent"
          });

          if(this.contentDocument) {
            iframe.css({height: this.contentDocument.body.scrollHeight});
          }
          /**
           * Al caricamento del contenuto dell'iframe viene attivato un setInterval in modo che
           * ogni 200ms venga controllata e nel caso aggiornata l'altezza dell'iframe.
           *
           * E' stato usato un setInterval perchè così l'iframe si può adattare al proprio contenuto,
           * ad esempio se contiene un collapse o se vengono aggiunti o tolti dei campi.
           *
           * @type {number}
           */
          iframe[0].refreshErrorsCounter = 0;
          iframe[0].refreshInterval = setInterval(function () {
            // Se il $modal non ha più la proprietà "bs.modal" vuol dire che il modale è stato chiuso.
            if (!self.$modal.data("bs.modal") || iframe[0].refreshErrorsCounter > 10){
              return clearInterval(iframe[0].refreshInterval);
            }
            try {
              self.update_iframe_size(iframeWindow)
            } catch (e) {
              iframe[0].refreshErrorsCounter ++
            }
          }, 200);

          self.update_iframe_size(iframeWindow)
        });

        iframe.attr("src", content);

        return;
      }

      this.trigger_event('show');

      this.$modal.find('.modal-body').html(content);

      this.set_title();

      if (this.options.wrap_links) {
        this.wrap_links();
      }
      // commentato perchè eseguiamo la funzione al ready del modale
      // this.bind_inputs();
      if ($.helper.order && this.url !== undefined) {
        if (this.order === undefined) {
          this.order = $.helper.order.create(this.url);
        } else {
          this.order.initialize(this.url.get_parameter_by_name('order') || '', this.url.get_parameter_by_name('verso') || '');
        }
      }
      this.trigger_event('shown');
      return this;
    },
    /**
     * Metodo che aggiorna la dimensione esterna dell'iframe in base al suo contenuto.
     * Questo metodo viene chiamato da un setInterval, ogni 200ms.
     *
     * @param { window } w
     */
    update_iframe_size: function (w) {
      if (!this.$modal.data("bs.modal")) {
        return;
      }
      try {
        w.frameElement && w.document.body;
      } catch (e) {
        throw new Error('Attenzione,cross origin bloccato dall\'iframe');
      }
      var iframe = w.frameElement;
      var new_height = w.document.body != null ? (w.document.body.scrollHeight || w.document.body.offsetHeight) : Number(iframe.style.height.replace('px', ''));
      var min_height = Number(iframe.style.minHeight.replace('px', ''));
      var curr_height = Number(iframe.style.height.replace("px", ""));

      if (curr_height !== new_height) {
        iframe.style.height = new_height + "px";
      }
    },
    show_loading  : function () {
      if (this.options.iframe){
        var svg = "<svg height='100%' width='100%' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'>" +
          "<image xlink:href='data:image/gif;base64,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' " +
          "x='50%' y='40%' width='16' height='16' />" +
          "<text x='50%' y='60%' fill='black' font-size='14' font-family='Arial' text-anchor='middle'>Caricamento in corso...</text>" +
          "</svg>";
        var svgEncoded = "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";

        this.$modal.find('.modal-body iframe').css({
          background: "url(\"data:image/svg+xml;base64," + svgEncoded + "\") 0px 0px no-repeat",
          // background: "url(../img/indicator.gif) center center no-repeat"
        });

        return;
      }

      this.$modal.find('.modal-body').html(
        $('<div></div>').attr({'class': 'no-result align-center loading'}).text('operazione in corso')
      );
      return this;
    },
    load_content_from_url: function (url, params) {
      if (!url || url == '') {
        return;
      }
      this.trigger_event('loading');
      var self = this;
      self.show_loading();

      if (self.url === undefined) {
        self.url = $.helper.url.create(url);
      } else {
        self.url.set_url(url);
      }
      self.add_url_params(params ? params : {});

      if (!self.options.iframe){
        $.ajax({
          ajax_loading: false,
          url         : self.url.change_parameter_by_name(this.url_params).toString(),
          success : function (resp, event_name, event) {
            // Risposta diversa da HTML
            if (event.getResponseHeader("content-type").indexOf("text/html") === -1) {
              try {
                resp = JSON.parse(resp);

                // Esito diverso da OK
                if (!resp || resp.esito !== "ok") {
                  return self.on_load_error(resp, event);
                }
              } catch (e) {
                return self.on_load_error(null, event);
              }
            }

            // Se la risposta è vuota, mostra l'alert di errore
            if (!resp) {
              return self.on_load_error(null, event);
            }

            // Salvo in una variabile il contenuto che andrà inserito nel modale.
            self.contentToLoad = resp;

            // Se l'option "loadInVariable" è true, non setta il contenuto del modale. Occorre quindi settare il contenuto manualmente.
            if (!self.options.loadInVariable) {
              self.set_content(resp);
            }

            self.trigger_event('loaded');
          },
          error   : function (e) {
            self.on_load_error(e.statusText, e)
          },
          dataType: 'html'
        });
      }else{
        self.set_content(self.url.change_parameter_by_name(this.url_params).toString());
      }
      return this;
    },
    reload_content       : function () {
      if (this.url === undefined) {
        return;
      }
      this.load_content_from_url(this.url.toString(), this.params);
      this.form_changed = false;
      return this;
    },
    wrap_links           : function () {
      var self = this;
      self.$modal.find('.modal-body').eq(0).find('a').on('click', function (e) {
        var href = $(this).attr('href');
        if (!href || href == '' || href == '#' || href.indexOf('javascript') >= 0) {
          return;
        }
        e.stopImmediatePropagation();
        self.load_content_from_url(href);
        return false;
      });
    },
    bind_inputs   : function () {
      var $f   = this.$modal.find('form'),
          self = this;
      if ($f.length <= 0) {
        return this;
      }

      // Attiva il binding sul change solo sugli input che non fanno parte degli elementi da evitare
      $f.not(".search, .no_change_alert, [fw-track-changes='false'], [fw-filters-form]").find(':input').on('change', function () {
        self.form_changed = true;
      });
      return this;
    },
    add_url_params: function (o) {
      $.extend(this.url_params, o);
      return this;
    },
    init_position : function () {
      var $d          = this.$modal.children('.modal-dialog').eq(0);
      this.position.x = $d.offset().left;
      this.position.y = $d.offset().top;
    },
    add_sub_title : function (html) {
      var $h = this.$modal.find('.modal-header').eq(0);
      if ($h.length <= 0) return;
      $h.append(html);
    },
    close         : function (prevent_form_changed_check) {
      if (prevent_form_changed_check) {
        this.form_changed = false;
      }

      this.$modal.modal("hide");
    },
    set_title     : function () {
      var iframe        = this.$modal.find(".modal-body iframe");
      var title         = this.$modal.find('.modal-header .modal-title');
      var on_page_title = iframe.length > 0 ? $(".page-title", iframe[0].contentDocument) : this.$modal.find(".modal-body .page-title");

      if (this.options["title_from_page"] === false ||
        ((title.text() && !on_page_title.text()) ||
          (!title.text() && !on_page_title.text())
        )) {
        return;
      }

      this.options["title_from_page"] = true;

      title.html(on_page_title.html());

      on_page_title.css("display", "none");
    },
    /**
     * Azione chiamata nel caso in cui ci sia un errore nel momento del caricamento
     * asincrono del contenuto di un modale.
     *
     * @param {String | JSONResponse} resp
     * @param {XMLHttpRequest} event
     */
    on_load_error : function (resp, event) {
      var self          = this;
      var error_message = "Siamo spiacenti ma a causa di un errore non &egrave; stato possibile caricare il contenuto desiderato.";
      var alert         = $("<div>");

      // Imposta lo stile del messaggio da mostrare.
      alert.css({
        "padding"         : ".75rem 1.25rem",
        "border"          : "1px solid transparent",
        "border-radius"   : ".25rem",
        "text-align"      : "center",
        "color"           : "#721c24",
        "background-color": "#f8d7da",
        "border-color"    : "#f5c6cb"
      });

      if (resp && resp.message) {
        error_message += "<br><br>Ecco l'errore riscontrato: <br><strong>" + resp.message + "</strong>"
      }

      self.set_content(alert.html(error_message));
    }
  };

  // Creazione ed implementazione del prototipo per la gestione dei popup modali nella pagina
  function modal_popups() {
    this.popups         = [];
    this.mousedown      = false;
    this.mouse_position = {x: 0, y: 0};
    /**
     * ### global_options
     * Opzioni globali per creazione di un modale
     * - **wrap_links** {Boolean} *Default false* Se true wrappa i link in modo da eseguirli all'interno del modale senza agire sull'intera pagina
     * - **draggable** {Boolean} *Default false* Se true permette al popup di essere spostato di posizione trascinandolo
     * - **base_z_index** {Number} *Default 1050*
     * - **version** {String} *Default bs3* versione di Bootstrap che determina markup differenti
     * - **callback_on_open** {Function} Funzione da eseguire una volta quanto visualizzato e caricato nel DOM il popup
     * - **callback_on_close** {Function} Funzione da eseguire una volta quanto chiuso e rimosso dal DOM il popup
     */
    this.global_options = {
      wrap_links: false,
      draggable: false,
      base_z_index: 1050,
      loadInVariable: false,
      contentToLoad: '',
      version: 'bs3',
      callback_on_open: function () {
      },
      callback_on_close: function () {
      }
    };
  }

  /**
   * ### modal_popups
   */
  modal_popups.prototype = {
    /**
     * #### popup
     * Creazione di un nuovo popup modale
     * @param {String} titolo
     * @param {String} width OBBLIGATORIA unita' di misura (px, % ecc.), se stringa vuota e' responsive
     * @param {String} contenuto se viene passato un testo viene visualizzato un popup modale statico con testo fisso, per caricare invece una pagina web in modo asincrono specificare il relativo URL
     * @param {Boolean} async se true effettua la chiamata in modo asincrono per caricare il popup, in questo caso "contenuto" deve essere un URL
     * @param {Object} [options] oggetto per le opzioni
     * @return {Object} modal_popup
     *
     * @deprecated
     */
    popup: function (titolo, width, contenuto, async, options) {

      if (!$.fn.modal) {
        throw new Error('Helper Javascript Modal necessita del plugin Modal della libreria Bootstrap');
      }

      var new_modal = new modal_popup(titolo, width, $.extend({}, this.global_options, options ? options : {}));

      new_modal.initialParms.async = async;

      this.bind_events(new_modal, async, contenuto);

      if (new_modal.options.draggable) {
        this.bind_dragging_events(new_modal);
      }

      new_modal.$modal.modal('show');

      return new_modal;
    },

    /**
     * #### open
     * Creazione di un nuovo popup modale
     * @param {ModalOptions} options
     * @return {ModalInstance} modal_popup
     */
    open: function (options) {

      if (!$.fn.modal) {
        throw new Error('Helper Javascript Modal necessita del plugin Modal della libreria Bootstrap');
      }

      var new_modal = new modal_popup(options.title || '', options.width || '', $.extend({}, this.global_options, options.options || {}));
      var loadAsync = typeof options.async === 'boolean' ? options.async : true;

      new_modal.initialParms.async = loadAsync;

      this.bind_events(new_modal, loadAsync, options.content || '');

      if (new_modal.options.draggable) {
        this.bind_dragging_events(new_modal);
      }

      new_modal.$modal.modal('show');
      let mainElement = document.querySelector('main');
      if(mainElement) {
        mainElement.classList.add('no-print')
      }

      return new_modal;
    },

    /**
     * #### store_popup
     * Creazione cookie con chiave random e come valore un oggetto codificato in base64 con tutte le proprietà di un modal da aprire in nuova pagina
     * Il modale viene aperto automaticamente al document.ready se nell'hash della pagina compare il parametro 'mto'
     * con il valore uguale alla chiave random del cookie
     *
     * Il metodo ritorna la chiave random
     * da assegnare al parametro 'mto' dell'hash della pagina che deve aprire il modal al caricamento
     * oppure da usare con il metodo open_stored_popup()
     *
     * @param {ModalOptions} options
     * @return {String} hash
     */
    store_popup: function (options) {

      var random     = btoa(Math.round(1 + Math.random() * (10e12 - 1)) + Date.now());
      var randomHash = random.slice(0, random.indexOf('='));

      if (!options) {
        throw new Error('Il metodo richiede necessariamente delle opzioni.');
      }

      if (!options.initialParms) {
        options.initialParms = {};
      }

      var finalOptions = {
        title: options.title || options.initialParms.titolo || '',
        width: options.width || options.initialParms.width || '',
        content: options.content || options.initialParms.contenuto || '',
        async: options.async || options.initialParms.async || false,
        options: options.options || options.initialParms.options || {},
      }

      $.helper.cookie_manager.set(randomHash, btoa(JSON.stringify(finalOptions)), 1);

      return randomHash;
    },

    /**
     * #### open_stored_popup
     * Creazione di un nuovo popup modale leggendo le proprietà da un oggetto salvato in un cookie
     * @param {String} hash
     * @return {ModalInstance} modal_popup
     */
    open_stored_popup: function (hash) {
      var new_modal;

      if (!$.fn.modal) {
        throw new Error('Helper Javascript Modal necessita del plugin Modal della libreria Bootstrap');
      }

      var encodedObj = $.helper.cookie_manager.get(hash);

      if (encodedObj) {
        var modalOptions = JSON.parse(atob(encodedObj));

        if (!modalOptions) {
          return;
        }

        new_modal = $.helper.modal_popups.open(modalOptions);
      }

      $.helper.cookie_manager.delete(hash);

      return new_modal;

    },

    bind_events: function (modal_popup, async, contenuto) {
      var self = this;
      modal_popup.$modal
        .appendTo('body')
        .modal({
          backdrop: 'static',
          keyboard: false,
          show: false
        })
        .on('hide.bs.modal', function (e) {
          if ($(this).data('modal_popup_obj').form_changed === true &&
            !confirm("Attenzione:\nDati non salvati. Sei sicuro di voler uscire?")) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return false;
          }
          for (var i = 0, l = self.popups.length; i < l; i++) {
            if (self.popups[i].$modal.is($(this))) {
              self.popups.splice(i, 1);
              break;
            }
          }
        })
        .on('hidden.bs.modal', function () {
          modal_popup.$modal.remove();
          if (self.popups.length <= 0) {
            $(d).off('.modal_popups');
          } else {
            $('body').addClass('modal-open');
          }

          typeof modal_popup.options.callback_on_close === 'string' && eval(modal_popup.options.callback_on_close);
          typeof modal_popup.options.callback_on_close === 'function' && modal_popup.options.callback_on_close();

          let mainElement = document.querySelector('main');
          if(mainElement) {
            mainElement.classList.remove('no-print')
          }
        })
        .on('show.bs.modal', function () {
          $('body').addClass('modal-open');
          var zindex = modal_popup.options.base_z_index + (10 * self.popups.length);
          $(this).css('z-index', zindex);
        })
        .on('shown.bs.modal', function () {
          var zindex = modal_popup.options.base_z_index + (10 * self.popups.length) - 1;
          $('.modal-backdrop').not('.modal-stack').css('z-index', zindex).addClass('modal-stack');
          modal_popup[async ? 'load_content_from_url' : 'set_content'](contenuto);
          self.popups.push(modal_popup);
          typeof modal_popup.options.callback_on_open === 'function' && modal_popup.options.callback_on_open(modal_popup);
        });
    },
    bind_dragging_events: function (modal_popup) {
      var self = this;
      var get_mouse_position   = function (e) {
        return {
          x: (d.all ? w.event.clientX : e.pageX),
          y: (d.all ? w.event.clientY : e.pageY)
        };
      };
      var calculate_transition = function ($m, e) {
        var mouse_pos = get_mouse_position(e);
        return {
          x: (mouse_pos.x - self.mouse_position.x) + parseFloat($m.attr('alpha-x') || 0),
          y: (mouse_pos.y - self.mouse_position.y) + parseFloat($m.attr('alpha-y') || 0)
        };
      };
      modal_popup.$modal.find('.modal-header.draggable').eq(0)
        .on('mousedown.modal.helper', function (e) {
          self.mousedown      = true;
          self.mouse_position = get_mouse_position(e);

          $(d).one('mouseup.modal.helper', function (e) {
            $(d).off('mousemove.modal.helper');
            self.mousedown = false;
            var $m = modal_popup.$modal.children('.modal-dialog').eq(0),
                tran       = calculate_transition($m, e);
            $m.attr({'alpha-x': tran.x, 'alpha-y': tran.y});
          });

          $(d).on('mousemove.modal.helper', function (e) {
            if (!self.mousedown) {
              return;
            }
            self.is_dragging = true;
            var $m = modal_popup.$modal.children('.modal-dialog').eq(0),
                tran         = calculate_transition($m, e),
                translate    = 'translate(' + tran.x + 'px, ' + tran.y + 'px)';
            $m.css({'webkitTransform': translate, 'transform': translate});
          });

        });
    },
    /**
     * #### reload_all_popups
     * Ricarica tutti i popup a cascata, dal piu' visibile al meno
     * @param {String} main_window_container se passato identifica il selettore della main window da ricaricare. Per sicurezza lavorare con gli ID
     * @return {Object} modal_popups
     */
    reload_all_popups   : function (main_window_container) {
      for (var i = this.popups.length - 1; i >= 0; i--) {
        this.popups[i].reload_content();
      }
      if (main_window_container && $('body').find(main_window_container).length > 0) {
        $.ajax({
          ajax_loading: false,
          url         : '',
          success     : function (html) {
            $(main_window_container).eq(0).replaceWith($(html).find(main_window_container).eq(0));
          },
          dataType    : 'html'
        });
      }
      return this;
    }
  };

  /**
   * ### Expose
   * Di default per ogni pagina viene inizializzato un oggetto modal_popups e reso disponibile globalmente sulla variabile **$.helper.modal_popups**
   */
  $.helper.modal_popups = new modal_popups();

  /**
   * #### get_closest_modal_popup_obj
   * A partire da un elemento interno al popup ritorna il corrispondente object modal_popup che lo contiene
   * Es: `$(elmento).get_closest_modal_popup_obj()`
   * @return {Object} modal_popup
   */
  $.fn.get_closest_modal_popup_obj = function () {
    var $m = this.hasClass('.modal_popup') ? this : this.eq(0).closest('.modal_popup');
    return $m && $m.data('modal_popup_obj') ? $m.data('modal_popup_obj') : undefined;
  };
  /**
   * #### reload_modal
   * Funzione che esegue il reload del popup
   * Puo' essere chiamato direttamente su un qualsiasi elemento html interno al popup
   * Es: `$(elmento).reload_modal()`
   */
  $.fn.reload_modal = function () {
    var m_obj = this.get_closest_modal_popup_obj();
    if (m_obj && m_obj.reload_content) {
      m_obj.reload_content();
    }
  };

  /**
   * ### onReady
   */
  $(function () {
    /**
     * Nel caso in cui ci sia un parametro nel hash 'mto' cerco il relativo valore tra le chiavi dei cookie.
     * Se trovo la chiave ne decodifico il valore ottenendo un oggetto con tutte le proprietà di un modale che vado ad aprire,
     * quindi cancello il cookie
     */
    var modal_to_open_id = $.helper.url.get_parameter_by_name('mto', true);
    if (modal_to_open_id != undefined) {

      $.helper.modal_popups.open_stored_popup(modal_to_open_id);

      $.helper.url.remove_parameter_by_name("mto", true);
      window.location.hash = $.helper.url.get_hash();
    }

    if (w.helper_modal_popups_initialized === true) return;
    w.helper_modal_popups_initialized = true;
    $(d)
      /**
       * E' possibile attivare l'apertura di un popup modale mediante l'inserimento di atributi *data* su di un elemento html:
       * - **data-modal-content** o **data-modal-async-url** per attivare il popup al click, da non usare assieme
       * -- data-modal-content contiene un testo html da mostrare nel popup
       * -- data-modal-async-url contiene un url dal quale verra' caricato in modo asincrono il contenuto html del popup
       * -- data-modal-callback-on-close contiene un url dal quale verra' caricato in modo asincrono il contenuto html del popup
       * - **modal-title** Facoltativo, contiene il titolo del popup
       * - **modal-width** Facoltativo, forza la dimensione del popup (px,%,ecc.)
       */
      .on('click', '[data-modal-content], [data-modal-async-url]', function (e) {
        e.preventDefault();
        var $self = $(this);
        var title = $self.data('modal-title') ? $self.data('modal-title') : '',
            width = $self.data('modal-width') ? document.documentElement.clientWidth < 1024 ? '94%' : $self.data('modal-width') : '',
            content = $self.data('modal-content') ? $self.data('modal-content') : '',
            url = $self.data('modal-async-url') ? $self.data('modal-async-url') : '',
            callback_on_close = $self.data('modal-callback-on-close') ? $self.data('modal-callback-on-close') : '',
            is_async = url && url != '' ? true : false;
        $.helper.modal_popups.open({
          content: is_async ? url : content,
          title: title,
          width: width,
          options: {callback_on_close: callback_on_close},
        });
        return false;
      })
      .on('before_change_order.order.helper before_filter', function (e, url) {
        if ($.helper.modal_popups.popups.length > 0) {
          e.preventDefault();
          $.helper.modal_popups.popups[$.helper.modal_popups.popups.length - 1].load_content_from_url(url);
          return false;
        }
      })
      .on('loaded.modal.helper', (event, modal_popup) => {
        // quando il modale è visibile e il js all'interno è stato eseguito
        // richiamo la funzione bind_input(), in questo modo si evita che qualche evento all'interno vada a modificare
        // il valore del form_changed
        modal_popup.$modal.ready(function(){
          modal_popup.bind_inputs();
        })
      });
  });

}(jQuery, document, window);

/**
 * ## pagination
 * Classe jquery di aiuto per la gestione della paginazione in javascript
 */
!function ($, d, w) {

  'use strict';

  if (w.helper_pagination_disabled === true) return;

  function pagination($element, params) {
    if (!$element || $element.length <= 0) {
      return console && console.warn('Helper pagination: Elemento non fornito');
    }
    this.$element     = $element;
    this.params       = params; //total_elements, per_page
    this.url_param    = 'page';
    this.url          = null;
    this.modal        = null;
    this.total_pages  = 0;
    this.current_page = 0;
    this.init();
  }

  pagination.prototype = {
    init     : function () {
      this.url_param += this.params.isolation ? ('_' + this.params.isolation) : '';
      this.total_pages = Math.ceil(Number(this.params.total_elements || 0) / Number(this.params.per_page || 0));
      if (!this.total_pages || this.total_pages <= 1) {
        return;
      }
      this.modal        = this.$element.get_closest_modal_popup_obj();
      this.url          = this.modal ? this.modal.url : $.helper.url;
      this.current_page = Number(this.url.get_parameter_by_name(this.url_param)) || 1;
      this.render();
    },
    render   : function () {
      var ie = $.helper.browser.detect_ie(),
          $container = $('<div class="table-pagination-container"></div>').css('max-width', this.$element.css('width') == '100%' ? '100%' : this.$element.width()),
          $arrow_l   = $('<a class="arrow left' + (this.current_page == 1 ? ' disabled' : '') + '" title="Visualizza pagina precedente">' + (!ie || ie > 8 ? '<' : '<') + '</a>'),
          $arrow_r   = $('<a class="arrow right' + (this.current_page == this.total_pages ? ' disabled' : '') + '" title="Visualizza pagina successiva">' + (!ie || ie > 8 ? '>' : '>') + '</a>'),
          $input     = $('<input type="text" value="' + this.current_page + '"' + (this.total_pages >= 1000 ? ' style="width:45px;"' : '') + '>');

      var self = this;
      $input
        .on('keydown', function (e) {
          var x = e.which || e.keyCode;
          if ($.inArray(x, [46, 8]) !== -1 || //backspace, delete
            (x >= 48 && x <= 57) || //num keyboard
            (x >= 96 && x <= 105)) { //num pad
            // let it happen, don't do anything
          } else if (x === 13) {
            return $(this).blur();
          } else {
            e.preventDefault();
            return false;
          }
        })
        .on('change', function () {
          self.show_page(Number($(this).val()));
        });

      $arrow_l.add($arrow_r).one('click', function (e) {
        e.preventDefault();
        !$(this).hasClass('disabled') && self.show_page(self.current_page + ($(this).hasClass('left') ? -1 : 1));
        return false;
      });

      $container.append(
        $arrow_l,
        $input,
        '<i>di<b>' + this.total_pages + '</b></i>',
        $arrow_r
      );

      this.$element.after($container);

    },
    show_page: function (new_page, executeEvent) {
      if (isNaN(new_page) || new_page <= 0 || new_page > this.total_pages) {
        return alert('Attenzione:\nNumero pagina non valido.');
      }
      if (executeEvent === undefined) {
        executeEvent = true;
      }
      if(executeEvent) {
        var event = $.Event("before_change_page.table.helper");
        $(d).trigger(event, new_page);
        if (event.isDefaultPrevented()) {
          return;
        }
      }
      var params = {};
      params[this.url_param] = new_page;
      var new_url = this.url.change_parameter_by_name(params);
      if (this.modal) {
        return this.modal.load_content_from_url(new_url);
      }
      $.helper.loading_frame.show();
      window.location = new_url;
    }
  };

  /**
   * ### Expose
   * #### setup_pagination
   * Inizializza la paginazione sul'elemento passato
   * Es: `$(elemento).setup_pagination({ total_elements: X, per_page: Y });`
   * @param {Object} params Oggetto contenente le informazioni di paginazione:
   *
   * - **total_elements** {Number||String} Numero righe totali
   * - **per_page** {Number||String} Numero righe per pagina
   * - **isolation** {String} se passato viene utilizzato per personalizzare il paramentro nell'url. Di default e' 'page', se passata una stringa si fa riferimento a 'page_{stringa}'
   *
   */
  $.fn.setup_pagination = function (params) {
    $.each(this, function () {
      var $this = $(this);
      if ($this.data('pagination') !== undefined) {
        return;
      }
      var p = new pagination($this, params || {});
      $this.data('pagination', p);
    });
    return this;
  };

}(jQuery, document, window);

/**
 * ## table
 * Classe jquery di aiuto per la gestione delle tabelle in javascript
 */
!function ($, w) {

  'use strict';

  if (w.helper_table_disabled === true) return;

  function table() {
    // Parametri di default per l'utilizzo delle libreria dotdotdot
    this.dotdotdot_options = {wrap: 'letter', watch: 'window'};
  }

  table.prototype = {
    /**
     * #### truncate_text
     * Funzione per il trocamento del testo (anche multilinea)
     * **Attenzione richiede la libreria dotdotdot**
     * @param {String} selector Identificativo del selettore per la tabella target
     */
    truncate_text: function (selector) {
      if (!$.fn.dotdotdot) {
        throw new Error('Helper Javascript Table necessita della libreria dotdotdot per troncare il testo');
      }
      var $target = selector !== undefined ? $(selector).filter('table') : $('table');
      if ($target.length <= 0) {
        return;
      }
      var self = this;
      $target.filter('.truncate-text').find('th, td').children().not(":empty").each(function () {
        $(this).dotdotdot(self.dotdotdot_options);
      });
    }
  };

  /**
   * ### Expose
   * Di default per ogni pagina viene inizializzato un oggetto table e reso disponibile globalmente sulla variabile **$.helper.table**
   */
  $.helper.table = new table();

  $.extend($.fn, {
    /**
     * #### tableFixedHeader
     * Fixa l'intestazione della tabella e non la fa scrollare
     */
    tableFixedHeader: function () {
      return this.on('scroll touchmove', function () {
        var translate = "translate3d(0," + this.scrollTop + "px,1px)";
        $(this).find('thead').css({transform: translate}).closest('table').css('transform-style', 'preserve-3d');
      });
    }
  });


}(jQuery, window);

/**
 * ## loading_frame
 * Classe per la gestione del loading frame di attesa
 * L'oggetto tiene conto di quante volte viene richiesto di visualizzare il frame di caricamento, nel caso venga richiamato piu' volte di seguito non viene mostrato piu' volte
 */
!function ($, w) {

  'use strict';

  if (w.helper_loading_frame_disabled === true) return;

  function loading_frame() {
    this.counter     = 0;
    this.css_class   = 'loading_frame';
    this.$temp_frame = null;
  }

  loading_frame.prototype = {
    show   : function (target) {
      var target_undefined = target === undefined;

      if (this.counter <= 0) {
        if (this.$temp_frame) {
          this.$temp_frame.stop().show(200);
        } else {
          this.$temp_frame = $('<div class="' + this.css_class + '"></div>');

          // se c'è il parametro "target", indica il container dove mostrare il loader
          if (target) {
            // Se il target contiene "document" indica che è un object Window, quindi ritorna il body del target
            if (target.document){
              target = $(target.document.body);
            } else if (target.body) {
              target = $(target.body);
            }else{
              this.$temp_frame.css("z-index", "9998");
            }

            // Se il target non è un istanza di jQuery, ritorna il target in jQuery.
            if (target instanceof jQuery === false) {
              target = $(target);
            }
          } else {
            target = $('body');
          }

          target.append(this.$temp_frame);
        }
      }
      this.counter++;
    },
    hide   : function () {
      this.counter--;
      if (this.counter <= 0) {
        var self = this;

        if (!this.$temp_frame) {
          return;
        }

        /**
         * Nel caso in cui il frame abbia una animazione css che si chiama "fade_in",
         * la sostituisce con il fade_out.
         *
         * Se non c'è quest'animazione esegue il fadeout tramite jquery.
         */
        if (this.$temp_frame.css('animation-name') === 'fade_in') {
          var animationDuration = +this.$temp_frame.css('animation-duration').replace(/s/, "") * 1000;
          this.$temp_frame.css('animation-name', 'fade_out');

          setTimeout(function() {
            self.$temp_frame.remove();
            self.$temp_frame = null;
          }, animationDuration);
        } else {
          this.$temp_frame.fadeOut(600, function() {
            self.$temp_frame = null;
            $(this).remove();
          });
        }
      }
    },
    reset  : function () {
      this.counter = 0;
      $('body').children('.' + this.css_class).remove();
    },
    /**
     * #### set_sub
     * Permette di aggiungere/aggiornare un ulteriore testo sotto quello stardard
     * @param {String} str
     * @param {Boolean} [hide_default]
     */
    set_sub: function (str, hide_default) {
      if (!this.$temp_frame) {
        return;
      }

      if (hide_default){
        this.$temp_frame.addClass("hide_default_text")
      }
      this.$temp_frame.html(str != '' ? '<div class="sub">' + str + '</div>' : '');
    }
  };

  var nlf = new loading_frame();

  /**
   * ### Expose
   * #### loading_frame
   * Sulla proprieta *loading_frame* di *$.helper* e' esposto l'oggetto loading_frame
   */
  $.helper.loading_frame = {'self': nlf, beforeunload: false};

  /**
   * #### show
   * Invoncando questa funzione si rende visibile il frame di caricamento
   * Accetta un parametro opzionale di tipo "window | DOMelement | jquery_element" che indica dove mostrare il loading_frame.
   * Questo può essere utile nell'eventualità in cui si stia lavorando dentro ad un iframe e si voglia mostrare il loading_frame nella pagina parent dell'iframe.
   * Se questo parametro è omesso, aggiunge il "loading_frame" alla pagina corrente.
   *   Es: `$.helper.loading_frame.show();`
   *   Es: `$.helper.loading_frame.show(target);`
   */
  $.helper.loading_frame.show = function (target) {
    nlf.show(target);
  };

  /**
   * #### hide
   * Invoncando questa funzione si nasconde il frame di caricamento
   * Es: `$.helper.loading_frame.hide();`
   */
  $.helper.loading_frame.hide = function () {
    nlf.hide();
  };

  $(w)
    /**
     * #### beforeunload
     * Se $.helper.loading_frame.beforeunload === true al cambio pagina viene mostrato il frame di caricamento
     * NB disabilitato con ie <= 10
     */
    .on("beforeunload", function (e) {
      var ie = $.helper.browser.detect_ie();
      if ($.helper.loading_frame.beforeunload === true && (ie === false || ie > 10)) {
        nlf.show();
      }
    })
    /**
     * #### pageshow
     * Nel caso la pagina si stata caricata dalla bfcache resetto lo stato del frame loading
     */
    .on("pageshow", function (e) {
      e.originalEvent.persisted && nlf.reset();
    });

}(jQuery, window);

/**
 * ## async_download
 * Classe jquery di aiuto per la gestione di download asincroni
 * All'avvio del download viene visualizzato il frame *loading_frame*
 */
!function ($, w, d) {

  'use strict';

  if (w.helper_async_download_disabled === true) return;

  $.helper.async_download = {'enabled': true};

  // Creazione e implementazione del prototipo
  function async_download($element, params) {
    /**
     * ### params
     * Definizione *Object* params
     * Contenuto:
     * - **url** => {String} **Obbligatorio**, identifica la pagina target
     * - **callback** => {Function} La funzione passata viene eseguita quanto il file e' pronto da scaricare. Non cambiare pagina nel callback!
     * - **method** => {String} GET/POST (default GET)
     * - **request_params** => {Object} Rappresentazione chiave valore delle informazioni da passare con la richiesta di download. es: { par_1: val_1, par_2: val_2 }
     */
    this.params = params || {};
    this.$element = $element;
    this.init();
  }

  async_download.prototype = {
    init           : function () {
      if (!this.params.url) {
        throw new Error('Helper async_download: parametro url non definito');
      }
      this.bind_click();
    },
    get_url        : function () {
      return typeof this.params.url === 'function' ?
        /**
         * Se l'url passato è una funzione viene eseguita, deve ritornare una stringa.
         * All'interno della funzione il this corrisponde all'oggetto jQuery cliccato.
         */
        this.params.url.call(this.$element) :
        this.params.url;
    },
    bind_click     : function () {
      var self = this;
      this.$element.on('click', function (e) {
        e.preventDefault();
        if (typeof Blob !== 'undefined') {
          $.helper.loading_frame.show();
          setTimeout(function () {
            self.xhr_download();
          }, 10);
        } else {
          setTimeout(function () {
            self.window_download();
          }, 10);
        }
        return false;
      });
    },
    get_file_name  : function (req) {
      var content = req.getResponseHeader('Content-Disposition');
      var content_parts = [];
      if( content ){
        content_parts = content.replace(/\s|"|'/g, '').match(/(filename=)([\s\S]+)/);
      }
      return content_parts.length >= 2 ?
        content_parts[2].split(';')[0] :
        this.get_url().split('/').pop().split('?')[0];
    },
    window_download: function () {
      var target = "asyncDownload_" + $.now();
      var downloadForm = document.createElement("form");
      downloadForm.style.display = 'none';
      downloadForm.target        = target;
      downloadForm.method        = this.params.method || "GET";
      downloadForm.action        = this.get_url();
      $.each(this.params.request_params || {}, function (name, value) {
        var requestData = document.createElement("input");
        requestData.type  = "text";
        requestData.name  = name;
        requestData.value = value;
        downloadForm.appendChild(requestData);
      });
      document.body.appendChild(downloadForm);
      var page = w.open("_blank", target, "top=10,left=10,width=50,height=50,status=no,menubar=no,toolbar=no,scrollbars=no");
      w.focus();
      if (page) {
        downloadForm.submit();
        downloadForm.parentNode.removeChild(downloadForm);
        setTimeout(function () {
          page.close();
        }, 180000);
      }
      this.callback();
    },
    xhr_download   : function () {
      var self = this;
      var req = new XMLHttpRequest();
      var save_link = d.createElementNS("http://www.w3.org/1999/xhtml", "a");

      function parse_json_resp() {
        try {
          var response = req.response;
          if (typeof response !== 'undefined' && response.type === 'application/json') {
            var reader = new FileReader();
            reader.addEventListener('loadend', function(e) {
              try {
                var resp_json = JSON.parse(reader.result);
                if (resp_json.esito && resp_json.esito === 'ko' && resp_json.message !== '') {
                  throw resp_json.message;
                } else {
                  throw "Attenzione: si sono verificati degli errori durante l'esecuzione.";
                }
              } catch (e) {
                console.log(e);
                alert(e);
              }
            });
            reader.readAsText(response);
          } else {
            throw 'Response:\n status => ' + req.status + '; content-size => ' + req.response.size;
          }
        } catch (err) {
          console.warn(err);
          alert('Attenzione: non \u00e8 stato possibile procedere allo scaricamento del file.');
        }

      }

      req.open(this.params.method || "GET", this.get_url(), true);
      req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
      req.setRequestHeader("X-Requested-With", "XMLHttpRequest");
      req.responseType = "blob";
      req.onload       = function () {
        if(Number(req.status) != 200 || req.response.size == '0'){
          parse_json_resp();
        } else {
          try {
            var blob = req.response;
            var file_name = self.get_file_name(req);
            var isIE = $.helper.browser.detect_ie() !== false;
            if (isIE) {
              w.navigator.msSaveOrOpenBlob(blob, file_name);
            } else {
              if ( !("download" in save_link) ){
                throw 'Browser non supportato (download not in)';
              }
              var object_url = w.URL.createObjectURL(blob);
              save_link.href     = object_url;
              save_link.download = file_name;
              //link.target = '_blank';
              self.click(save_link);
              setTimeout(function () {
                (w.URL||w.webkitURL||w).revokeObjectURL(object_url);
              }, 1000*40);
            }
            self.callback();
          } catch (e) {
            console.error('Errore in fase di download: ', e);
            alert('Attenzione: si e\' verificato un errore in fase di download.');
          }
        }

        $.helper.loading_frame.hide();
      };
      req.send($.param(this.params.request_params || {}));
    },
    click          : function(node) {
      var event = new MouseEvent("click");
      node.dispatchEvent(event);
    },
    callback       : function () {
      if (this.params.callback && typeof this.params.callback === 'function') {
        this.params.callback.call();
      }
    }
  };

  /**
   * ### Expose
   * #### async_download
   * Metodo per attivare su un elemento jQuery un download asincrono
   * Va passato come parametro un *Object*, vedere definizione di params
   * Es: `$(elemento).async_download({ url: '...' });`
   * @param {Object} params
   */
  $.fn.async_download = function (params) {
    $.each(this, function () {
      var $this = $(this);
      if ($this.data('async_download_obj')) {
        return;
      }
      var nad = new async_download($this, params);
      $this.data('async_download_obj', nad);
    });
    return this;
  };

  /**
   * #### download_this
   * Funzione per richiamare manualmente un download asyncrono senza attaccarlo ad un oggetto appartenente alla pagina
   * Va passato come parametro una *String* (url del file) o *Object* (vedere definizione di params in questo caso)
   * Es: `$.helper.async_download.download_this({ url: '...' });`
   * @param {String|Object} params
   */
  $.helper.async_download.download_this = function (params) {
    if (typeof params !== 'object') {
      params = {url: params};
    }
    var $fake_link = $('<i></i>').css('display', 'none').appendTo('body');
    $fake_link.async_download(params).trigger('click');
    setTimeout(function () {
      $fake_link.remove();
    }, 100);
  };

}(jQuery, window, document);

/**
 * ## browser
 * Metodi utili legati al browser in uso
 */
!function ($, w) {

  'use strict';

  if (w.helper_browser_disabled === true) return;

  function browser() {
    this.ua = w.navigator.userAgent || w.navigator.vendor || w.opera;
  }

  browser.prototype = {
    /**
     * #### detect_ie
     * Determina se il browser attivo e' MS Internet Explorer, in caso affermativo ne ritorna il numero di versione,
     * diversamente FALSE
     * @return {Number|Boolean}
     */
    detect_ie     : function () {
      var msie = this.ua.indexOf('MSIE ');
      if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(this.ua.substring(msie + 5, this.ua.indexOf('.', msie)), 10);
      }

      var trident = this.ua.indexOf('Trident/');
      if (trident > 0) {
        // IE 11 => return version number
        var rv = this.ua.indexOf('rv:');
        return parseInt(this.ua.substring(rv + 3, this.ua.indexOf('.', rv)), 10);
      }

      var edge = this.ua.indexOf('Edge/');
      if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(this.ua.substring(edge + 5, this.ua.indexOf('.', edge)), 10);
      }
      return false;
    },
    /**
     * #### detect_ios
     * Determina se si tratta di un dispositivo iOS
     * @return {Boolean}
     */
    detect_ios    : function () {
      return /ip(ad|hone|od)/.test(this.ua.toLowerCase());
    },
    /**
     * #### detect_android
     * Determina se si tratta di un dispositivo Android
     * @return {Boolean}
     */
    detect_android: function () {
      return this.ua.toLowerCase().indexOf('android') !== -1;
    },
    /**
     * #### detect_mobile
     * Determina se si tratta di un browser mobile
     * @return {Boolean}
     */
    detect_mobile : function () {
      return /avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|playbook|silk|iemobile|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(this.ua.toLowerCase()) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|e\-|e\/|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(di|rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|xda(\-|2|g)|yas\-|your|zeto|zte\-/i.test(this.ua.substr(0, 4).toLowerCase());
    }
  };

  /**
   * ### Expose
   * Tutti i metodi sono esposti pubblicamente sulla proprieta' $.helper.browser
   * Es: `$.helper.browser.detect_ie()`
   */
  $.helper.browser = new browser();

}(jQuery, window);

/**
 * ## unload_helper
 * Classe jquery di aiuto per la gestione del messaggio di avviso quando si esce da una pagina non avendo salvato il contenuto di una form
 * Per rendere una form non sensibile al controllo aggiungere la classe *forcesubmit*
 * Le form di ricerca, con classe *search* sono automaticamente rese insensibili all'avviso
 */
!function ($, w) {

  'use strict';

  if (w.helper_unload_disabled === true) return;

  var config = {
    avoid_form_classes: ['forcesubmit', 'search'],
    message           : 'Attenzione: nella pagina sono presenti dati non salvati.'
  };

  function unload_helper() {
    this.enabled = false;
    this.unsaved = false;
    this.$forms  = [];
  }

  unload_helper.prototype = {
    enable           : function () {
      this.$forms = $('form').not('.' + config.avoid_form_classes.join(',.'));
      if (this.$forms.length <= 0) {
        return;
      }
      this.bind_form_event();
      this.bind_window_event();
      var self = this;
      $(w).on('load', function () {
        self.enabled = true;
        self.reset_state();
      });
    },
    bind_form_event  : function () {
      var self = this;
      this.$forms.off('.unload.helper')
        .on('keyup.unload.helper change.unload.helper', ':input', function () {
          self.unsaved = true;
        })
        .on('submit.unload.helper', function () {
          self.reset_state();
        });
    },
    bind_window_event: function () {
      var self = this;
      $(w).bind('beforeunload', function () {
        if (self.unsaved ) {
          return config.message;
        }
      });
    },
    reset_state      : function () {
      this.unsaved = false;
    }
  };

  /**
   * ### Expose
   * #### unload_helper
   * Per attivare la verifica delle form modificate chiamare il metodo
   * `$.helper.unload_helper.enable()`
   * Per resettare lo stato di controllo:
   * `$.helper.unload_helper.reset_state()`
   */
  $.helper.unload_helper = new unload_helper();

}(jQuery, window);

/**
 * ## cookie_manager
 * Classe jquery di aiuto per la gestione cookie
 */
!function (d) {

  'use strict';

  function cookie_manager() {
  }

  cookie_manager.prototype = {
    /**
     * #### get cookie value
     * @param {String} name
     */
    get   : function (name) {
      if (!("cookie" in d)) {
        console.warn('Impossibile accedere ai cookie'); return false;
      }
      var cookies = d.cookie.split(';');

      for (var i = 0, l = cookies.length; i < l; i++) {
        var string = cookies[i];
        var key    = string.slice(0, string.indexOf("="));
        var value  = string.slice(string.indexOf("=") + 1);

        if ($.trim(key) == name) {
          return $.trim(value);
        }
      }
      return false;
    },
    /**
     * #### set cookie value
     * @param {String} name
     * @param {String} value
     * @param {int} expiration in days if not set cookie is create as session cookie
     * @param {String} path not required
     */
    set   : function (name, value, expiration, path) {
      var date = new Date();

      if (!d.cookie && d.cookie !== "") {
        return console.warn('Impossibile accedere ai cookie');
      } else if (d.cookie === "") {
        var newExpDate = date.getTime() + (86400 * 1000);

        // Se la libreria che gestisce i cookie è caricata, aspetta che l'utente dia la conferma,
        // prima di settare qualsiasi cookie.
        if (typeof $cookie_law_queue === 'function' && !CookieLaw.get_cookie_status()) {
          window.$cookie_law_queue(function() {
            d.cookie = 'cookiesInitiated=true;expires=' + new Date(newExpDate).toUTCString();
          });
        } else {
          d.cookie = 'cookiesInitiated=true;expires=' + new Date(newExpDate).toUTCString();
        }
      }

      date.setTime(date.getTime() + ((expiration || 0) * 86400 * 1000));

      var expires = expiration ? ('expires=' + date.toUTCString()) : '';

      // Se la libreria che gestisce i cookie è caricata, aspetta che l'utente dia la conferma,
      // prima di settare qualsiasi cookie.
      if (typeof $cookie_law_queue === 'function' && !CookieLaw.get_cookie_status()) {
        window.$cookie_law_queue(function() {
          d.cookie = name + '=' + value + '; ' + expires + '; path=' + (path || '/');
        });
      } else {
        d.cookie = name + '=' + value + '; ' + expires + '; path=' + (path || '/');
      }
      return this;
    },
    /**
     * #### delete a cookie
     * @param {String} name
     */
    delete: function (name) {
      return this.set(name, '', -100);
    }
  };

  /**
   * ### Expose
   */
  $.helper.cookie_manager = new cookie_manager();

}(document);

/**
 * ## jumper
 * Classe jquery di aiuto per la gestione dei salti tra le pagine
 */
!function (w) {

  'use strict';

  var cookie_name = 'jumper';

  function Jumper() {
    this.jumps = [];
    this.init();
  }

  Jumper.prototype = {
    init        : function () {
      try {
        this.jumps = JSON.parse(decodeURIComponent($.helper.cookie_manager.get(cookie_name))) || [];
      } catch (err) {
        console.log(err)
      }
    },
    /**
     * #### jump_to
     * Jump to an url (relative or absolute)
     * @param {String} to
     */
    jump_to     : function (to) {
      var absolute_to = $.helper.url.create(to).get_request_file_name();
      //this.remove_to(absolute_to);
      this.jumps.push({
        from : $.helper.url.get_request_file_name(),
        query: $.helper.url.get_url_params()||{},
        to   : absolute_to
      });
      this.store_cookie();
      w.location = to;
    },
    get_parent  : function ( current, steps, debug, from_index ) {
      var target = false;
      var i = from_index!== undefined ? from_index : (this.jumps.length - 1);
      for ( ; i >= 0; i-- ) {
        if ( this.jumps[i].to !== $.helper.url.create(current).get_request_file_name() ) continue;
        target = $.helper.url.create(this.jumps[i].from).change_parameter_by_name(this.jumps[i].query).toString();
        if (debug !== true) this.remove_jump(i);
        break;
      }
      if (steps > 1) {
        return target ?
          this.get_parent(target, steps - 1, debug, i - 1) :
          current;
      }
      return target;
    },
    /**
     * #### jump_back
     * Jump back to parent page preserving query string
     * Note: it's possible to set a default_url in case of no parent matching
     * @param {String} default_url relative or absolute path
     * @param {Number|String} backTo number of steps to go back, if `first` jump back to first parent
     * @param {Boolean} debug if true prevent jump and log target url in console
     * @throws Error in case no matching found
     */
    jump_back   : function ( default_url, backTo, debug ) {
      if (typeof backTo === 'undefined' || backTo <= 0) backTo = 1;
      else if (backTo === 'first') backTo = 1000;
      var current = $.helper.url.toString();
      var target = this.get_parent(current, backTo, debug);
      if (!target && default_url) target = default_url;
      if (!target) throw 'jump_back => nessun match trovato per effettuare il salto';
      if (debug) return console.log('jump_back => ', target);
      $.helper.loading_frame.show();
      w.location = target;
      $.helper.loading_frame.hide();
    },
    remove_to   : function (to) {
      for (var i = 0; i < this.jumps.length; i++ ) {
        if ( this.jumps[i].to === to ) {
          this.remove_jump(i);
          break;
        }
      }
    },
    remove_jump : function (i) {
      this.jumps.splice(i, 1);
      this.store_cookie();
    },
    /**
     * Check if ther's possibility for jump_back
     */

    is_from_jump : function () {
      return this.jumps.some(function (jump) {
        return window.location.href.split('?')[0] === jump.to
      })
    },
    /**
     * Store jumps in cookie
     */
    store_cookie: function () {
      $.helper.cookie_manager.set(cookie_name, encodeURIComponent(JSON.stringify(this.jumps)));
    },
    /**
     * #### reset
     * Empty saved jumps
     */
    reset: function () {
      this.jumps = [];
      this.store_cookie();
    }
  };

  /**
   * ### Expose
   */
  $.helper.jumper = new Jumper();
}(window);

/**
 * ## conta_click
 * Classe jquery di aiuto per raggiungere l'andpoint che conta i click
 */
!function (w) {

  'use strict';


  function ContaClick() {
  }

  ContaClick.prototype = {
    /**
     * #### add_click
     * Increment counter click
     * @param {String} nome_file
     * @param {String} [recaptcha_front_key=null]
     * @param {String} [action]
     * @returns {boolean}
     */
    add_click: function (nome_file, recaptcha_front_key = null, action) {
      let message;
      let gRecaptchaResponse;

      if (!nome_file) {
        message = '$.helper.conta_click non funziona senza il parametro che indica quale argomento bisogna incrementare';

        if (w.fallco && w.fallco.console) {
          w.fallco.console.warn(message);
        } else {
          console.warn(message);
        }
        return false;
      }

      if (typeof window.grecaptcha !== 'object' && !(recaptcha_front_key || window.recaptcha_front_key)) {

        if (!recaptcha_front_key && !window.recaptcha_front_key) {
          message = '$.helper.conta_click non riesce a recuperare la Front Key.';

          if (w.fallco && w.fallco.console) {
            w.fallco.console.warn(message);
          } else {
            console.warn(message);
          }
        } else if (typeof window.grecaptcha !== 'object') {
          message = '$.helper.conta_click non trova instanziato il sistema Recaptcha quindi non viene inviato il token.';

          if (w.fallco && w.fallco.console) {
            w.fallco.console.warn(message);
          } else {
            console.warn(message);
          }
        }

        return this._ajaxCall(nome_file, null);

      } else if (typeof window.grecaptcha !== 'object' && (recaptcha_front_key || window.recaptcha_front_key)) {

        let googleScript = document.createElement("script");
        googleScript.setAttribute("src", "https://www.google.com/recaptcha/api.js?render=" + recaptcha_front_key || window.recaptcha_front_key);
        googleScript.setAttribute("async", true);
        googleScript.setAttribute("defer", true);
        document.head.appendChild(googleScript);


        googleScript.onload = () => {
          window.grecaptcha.ready(() => {
            window.grecaptcha.execute(recaptcha_front_key, { action: action }).then(async token => {

              return !!await this._ajaxCall(nome_file, token);

            });
          });
        }
      } else {

        recaptcha_front_key = recaptcha_front_key || window.recaptcha_front_key || null;
        action = action || 'homepage';

        if (!recaptcha_front_key) {
          message = '$.helper.conta_click non riesce a recuperare la Front Key.';

          if (w.fallco && w.fallco.console) {
            w.fallco.console.warn(message);
          } else {
            console.warn(message);
          }
          return false;
        }

        grecaptcha.ready(() => {
          grecaptcha.execute(recaptcha_front_key, {action: action}).then(async token => {

            return !!await this._ajaxCall(nome_file, token);

          });
        });
      }

    },
    /**
     * #### _ajaxCall
     * Ajax call to endpoint
     * @param {String} nome_file
     * @param {String} gRecaptchaResponse
     */
    _ajaxCall: async function (nome_file, gRecaptchaResponse) {
      let message;
      let data = {};

      if (!w.fallco || !w.fallco.ajax) {
        message = '$.helper.conta_click non funziona correttamente: richiede fallco.ajax()';

        if (w.fallco && w.fallco.console) {
          w.fallco.console.warn(message);
        } else {
          console.warn(message);
        }
        return false;
      }

      if (!nome_file) {
        message = '$.helper.conta_click non funziona senza il parametro che indica quale contatore bisogna incrementare.';

        if (w.fallco && w.fallco.console) {
          w.fallco.console.warn(message);
        } else {
          console.warn(message);
        }
        return false;
      }

      data.nome_file = nome_file;
      if (gRecaptchaResponse) {
        data['g-recaptcha-response'] = gRecaptchaResponse;
      }

      const locale = ["locale", "localhost"].some(element => window.location.host.includes(element));
      const url    = locale ? '/web/conta_click' : '/conta_click';

      return w.fallco.ajax.post({
        url: url,
        data: data,
        messages: {
          suppress: 'all'
        },
        returnPromise: true,
      }).then(function (resp) {
        message = '$.helper.conta_click incrementato: ' + nome_file;

        if (fallco.console) {
          fallco.console.log(message)
        } else {
          console.log(message)
        }
      }).catch(function (error) {
        message = '$.helper.conta_click errore: ' + error.message;

        if (fallco.console) {
          fallco.console.error(message)
        } else {
          console.error(message)
        }
      });
    }
  };

  /**
   * ### Expose
   */
  $.helper.conta_click = new ContaClick();

}(window);